import { DocumentsList } from "Components/LegalDocuments/DocumentsList";
import { BlDivider } from "Components/Shared/BlDivider";
import { useIsUserInMooneLite } from "Hooks/useIsUserInMooneLite";
import { getApiUrl } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Pages.Content.LegalDocuments.Documents;

export const CustomerLegalDocuments = () => {
  const { t } = useResource();
  // Legal docs follow the user's tier, not their current verification state — an Expired user
  // still has the FullMoone contract, only their doc data is stale.
  const { isLiteTier } = useIsUserInMooneLite();

  const apiUrl = getApiUrl();

  const mooneLiteDocuments = [
    {
      title: t(COMPONENT_RESOURCES.mooneLiteTerms.title),
      url: t(COMPONENT_RESOURCES.mooneLiteTerms.url, { apiUrl }),
    },
  ];

  if (isLiteTier) {
    return <DocumentsList documents={mooneLiteDocuments} />;
  }

  const fullMooneDocuments = [
    {
      title: t(COMPONENT_RESOURCES.paymentServicesContract.title),
      url: t(COMPONENT_RESOURCES.paymentServicesContract.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.generalBusinessTerms.title),
      url: t(COMPONENT_RESOURCES.generalBusinessTerms.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.aisPisProductTerms.title),
      url: t(COMPONENT_RESOURCES.aisPisProductTerms.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.priceList.Standard.title),
      url: t(COMPONENT_RESOURCES.priceList.Standard.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.complaintRules.title),
      url: t(COMPONENT_RESOURCES.complaintRules.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.dataProtectionMemorandum.title),
      url: t(COMPONENT_RESOURCES.dataProtectionMemorandum.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.precontractInformation.title),
      url: t(COMPONENT_RESOURCES.precontractInformation.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.thanksToYou.title),
      url: t(COMPONENT_RESOURCES.thanksToYou.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.stardust.title),
      url: t(COMPONENT_RESOURCES.stardust.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.stardustCurrentTerms.title),
      url: t(COMPONENT_RESOURCES.stardustCurrentTerms.url, { apiUrl }),
    },
  ];

  return (
    <>
      <DocumentsList documents={fullMooneDocuments} />
      <BlDivider
        text={t(Resources.Pages.Content.LegalDocuments.previousVersions)}
      />
      <DocumentsList
        documents={[
          {
            title: t(COMPONENT_RESOURCES.previousGeneralBusinessTerms.title),
            url: t(COMPONENT_RESOURCES.previousGeneralBusinessTerms.url, {
              apiUrl,
            }),
          },
          {
            title: t(
              COMPONENT_RESOURCES.previousDataProtectionMemorandum.title,
            ),
            url: t(COMPONENT_RESOURCES.previousDataProtectionMemorandum.url, {
              apiUrl,
            }),
          },
          {
            title: t(
              COMPONENT_RESOURCES.previousDataProtectionMemorandum2.title,
            ),
            url: t(COMPONENT_RESOURCES.previousDataProtectionMemorandum2.url, {
              apiUrl,
            }),
          },
        ]}
      />
    </>
  );
};
